import React, { useState } from 'react';
import { streetlearnApi } from '../api';
import { showToast } from '../../components/toast';

const BulkGrantModal = ({ show, onHide, onSuccess }) => {
  const [phonesText, setPhonesText] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const phones = phonesText
      .split(/[\n,;]+/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);

    if (!phones.length) {
      showToast.error('Please enter at least one phone number');
      return;
    }
    if (!note.trim()) {
      showToast.error('Please enter a note');
      return;
    }

    try {
      setLoading(true);
      setResult(null);
      const res = await streetlearnApi.bulkGrantEntitlements({
        phones,
        note: note.trim(),
      });
      setResult(res);
      showToast.success(`Bulk grant completed! Granted: ${res.granted + res.created_and_granted}`);
      if (onSuccess) onSuccess();
    } catch (err) {
      showToast.error(err.response?.data?.message || 'Failed to process bulk grant');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setPhonesText('');
    setNote('');
    setResult(null);
    onHide();
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header d-flex justify-content-between align-items-center">
              <h4 className="modal-title font-bold m-0">Bulk Grant Lifetime Access</h4>
              <button
                type="button"
                className="close"
                style={{ border: 'none', background: 'transparent', fontSize: '24px', lineHeight: '1', cursor: 'pointer', padding: '0 5px' }}
                onClick={handleReset}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {result && (
                <div className="alert alert-info">
                  <h5 className="font-bold mb-2">Bulk Grant Results Summary:</h5>
                  <ul className="mb-0">
                    <li>Total Numbers Provided: <strong>{result.total}</strong></li>
                    <li>New Access Granted to Existing Learners: <strong>{result.granted}</strong></li>
                    <li>New Learners Created & Access Granted: <strong>{result.created_and_granted}</strong></li>
                    <li>Already Entitled: <strong>{result.already_entitled}</strong></li>
                    <li>Invalid Phone Numbers: <strong>{result.invalid}</strong></li>
                  </ul>
                </div>
              )}

              <div className="form-group mb-3">
                <label className="font-semibold text-sm">
                  Mobile Numbers (One per line or comma-separated) <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="6"
                  placeholder="9876543210&#10;9898989898&#10;9123456789"
                  value={phonesText}
                  onChange={(e) => setPhonesText(e.target.value)}
                  required
                  disabled={loading}
                />
                <span className="text-muted small">
                  Indian 10-digit mobile numbers. If an account does not exist, it will be automatically created so access is unlocked when the user first signs in.
                </span>
              </div>

              <div className="form-group mb-3">
                <label className="font-semibold text-sm">
                  Campaign / Reason Note <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Diwali promotional grant / VIP client campaign"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={handleReset}
                disabled={loading}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary btn-sm" disabled={loading}>
                {loading ? 'Processing...' : 'Run Bulk Grant'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BulkGrantModal;
